export const JIRA_LABELS = {
	evincedScannerIssue: 'evinced-scanner-issue',
	evincedWfaIssue: 'evinced-wfa-issue',
	evinceWebSDKIssue: 'evinced-wsdk-issue',
	evincedMFAIssue: 'evinced-mfa-issue',
	evincedmobileSDKIssue: 'evinced-msdk-issue'
};
